import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core";
import { Colors } from "../../helpers/theme";

const useStyles = makeStyles((theme) => ({
  projectdetail: {
    "& h2": {
      [theme.breakpoints.down("md")]: {
        marginBottom: "12px",
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },
    "& .border": {
      borderBottom: `1px solid ${alpha(Colors.black, 0.1)}`,
    },

    "& .mainBox": {
      background: Colors.white,
      border: `1px solid ${alpha(Colors.secondaryWhite, 1)}`,
      borderRadius: "8px",
      [theme.breakpoints.down("sm")]: {
        border: "none",
        borderRadius: "0",
        paddingTop: theme.spacing(3),
        borderTop: `1px solid ${alpha(Colors.black, 0.1)}`,
      },
    },

    "& .sub-mainBox": {
      [theme.breakpoints.down("md")]: {
        minWidth: "50%",
      },
    },
    "& .img-project": {
      width: "64px",
      height: "64px",
      objectFit: "cover",
      borderRadius: "50%",
      [theme.breakpoints.down("md")]: {
        maxWidth: "48px",
        width: "48px",
        height: "48px",
        objectFit: "cover",
      },
    },
    "& .btn-view": {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "120px",

        marginTop: "12px",
      },
    },

    "& .MuiButton-label": {
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    "& .box-relative": {
      position: "relative",
    },
    "& .icon-box": {
      [theme.breakpoints.down("sm")]: {
        position: "unset",
        marginTop: "16px",
        right: "0px",
        bottom: "-2px",
      },
    },

    "& .kyc_error": {
      color: "#E23636",
      fontSize: "14px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "15px",
    },
    "& .kyc_warning": {
      color: " #FFB818",
      fontSize: "14px",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginLeft: "15px",
    },

    "& .text-color ": {
      color: Colors.darkSlate,
      [theme.breakpoints.down("md")]: {
        fontSize: theme.typography.subtitle1.fontSize,
      },
    },
    "& .MuiButton-contained": {
      [theme.breakpoints.down("xs")]: {
        minWidth: "100%",
      },
    },
    "& .btn-box": {
      [theme.breakpoints.down("md")]: {
        marginLeft: theme.spacing(8),
      },
      [theme.breakpoints.down("sm")]: {
        marginLeft: theme.spacing(6),
      },
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(0),
      },
    },
    "& .btn-medium": {
      padding: " 10px 48px",
    },
    "& .disabled-invest-input": {
      outline: "none",
    },
    "& .fs": {
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.body1.fontSize,
        "& span": {
          fontSize: theme.typography.body1.fontSize,
        },
      },
    },
    "& .imageAlign": {
      verticalAlign: "middle",
      marginRight: "12px",
      marginTop: "-2px",
    },
    "& .back-btn": {
      "& .MuiButton-label": {
        fontSize: "12px",
      },
      "& .MuiButton-startIcon": {
        marginRight: "4px",
      },
    },

    "& .color": {
      //Progress text
      color: Colors.greySlate,
    },
    "& .MuiTab-textColorSecondary.Mui-selected": {
      background: Colors.black,
      color: Colors.white,
    },
    "& .MuiTab-textColorSecondary": {
      marginRight: theme.spacing(3),
    },

    //Project member Tab 1
    "& .projectMember": {
      background: Colors.aliceblue,
      borderRadius: "20px",
      height: "600px",
    },
    //economic tab 2
    "& .economicTab": {
      border: `1px solid ${alpha(Colors.aliceblue, 1)}`,
      boxSizing: "border-box",
      borderRadius: "20px",
      padding: theme.spacing(0),
    },
    //roadmap
    "& .img-radius": {
      borderRadius: "20px",
    },

    //invesform
    "& .investform": {
      [theme.breakpoints.down("md")]: {
        marginLeft: "65px",
      },
      "@media(min-width: 600px) and (max-width: 959px)": {
        marginLeft: "55px",
      },
      [theme.breakpoints.down("xs")]: {
        marginLeft: "0",
      },
    },
    "& .select-stablecoin-dropdown": {
      marginTop: theme.spacing(1),
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    "& .img-border": {
      width: " 32px",
      height: "32px",
      border: `1px solid ${alpha(Colors.Solitude, 1)}`,
      borderRadius: "12px",
      textAlign: "center",
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      "&:hover": {
        border: `1px solid ${alpha(Colors.green, 1)}`,
        background: Colors.green,
        "& svg path": {
          fill: "white",
          stroke: "white",
          "&:last-child": {
            stroke: "none",
          },
        },
      },
    },
  },
}));

export default useStyles;
